import logoImage from './Logo.png';

// ==============================|| LOGO IMAGE ||============================== //

export default function LogoMain() {
  return <img src={logoImage} alt="AccuSmart Logo" style={{ height: '48px' }} />;
}
